import Paragraph from './Paragraph.vue'

export default Paragraph



// WEBPACK FOOTER //
// ./node_modules/gvue/src/core/Paragraph/index.js